import KoreroText from '../../../../../KoreroText'
import { KoreroTexts } from './Texts'

export const s2m01 =
    <div>
        {KoreroTexts.map(text => <KoreroText key={text.id} korero={text.korero} speaker={text.speaker} />)}
    </div>